export class SortFilter {
  column: string;
  label: string;
  direction: 'asc' | 'desc';

  constructor(column: string, label: string, isAsc: boolean) {
    this.column = column;
    this.label = label;
    this.direction = isAsc ? 'asc' : 'desc';
  }
}

export class PastReportFilter {
  column: string;
  label: string;

  constructor(column: string, label: string) {
    this.column = column;
    this.label = label;
  }
}
